import { useEventTypeContext } from 'features/event_type_provider'

import { EditForm } from './sections/edit_form'
import { NewForm } from './sections/new_form'
import { SectionDetail } from './sections/section_detail'

export const SectionPane = ({ sectionKey }) => {
  const { eventType, isCreation } = useEventTypeContext()

  if (sectionKey) return <SectionDetail sectionKey={sectionKey} eventType={eventType} />

  if (isCreation) { return <NewForm /> }

  return <EditForm />
}
